// extracted by mini-css-extract-plugin
export default {"root":"jlIih","title":"T_rja","form":"euYOX","button":"CQ1wF","closeBtn":"e_oxJ","optionsButton":"TPY4g"};